export const TCP_HOST_PORT = 'TCP_HOST_PORT';
export const ABSOLUTE_PATH_FILE = 'ABSOLUTE_PATH_FILE';

export interface RedAssetConnectionType {
  name: string;
  description: string;
}